__turbopack_context__.v({
  "clearButton": "SearchBar-module__dIdV1W__clearButton",
  "dropdown": "SearchBar-module__dIdV1W__dropdown",
  "dropdownCategory": "SearchBar-module__dIdV1W__dropdownCategory",
  "dropdownEmpty": "SearchBar-module__dIdV1W__dropdownEmpty",
  "dropdownHash": "SearchBar-module__dIdV1W__dropdownHash",
  "dropdownIcon": "SearchBar-module__dIdV1W__dropdownIcon",
  "dropdownInfo": "SearchBar-module__dIdV1W__dropdownInfo",
  "dropdownItem": "SearchBar-module__dIdV1W__dropdownItem",
  "dropdownLoading": "SearchBar-module__dIdV1W__dropdownLoading",
  "dropdownTime": "SearchBar-module__dIdV1W__dropdownTime",
  "dropdownTitle": "SearchBar-module__dIdV1W__dropdownTitle",
  "searchFormDesktop": "SearchBar-module__dIdV1W__searchFormDesktop",
  "searchFormMobile": "SearchBar-module__dIdV1W__searchFormMobile",
  "searchIcon": "SearchBar-module__dIdV1W__searchIcon",
  "searchInput": "SearchBar-module__dIdV1W__searchInput",
  "searchInputWrapper": "SearchBar-module__dIdV1W__searchInputWrapper",
});
